import { Logger, SupportedProducts } from 'atp-api-logger';

import { settings } from '@/_config';

let product = SupportedProducts.INSTRUCTOR_PORTAL;
if (settings.isSWA) {
  product = SupportedProducts.SWA;
} else if (settings.isUnified) {
  product = SupportedProducts.UNIFIED_CHECKOUT;
}

export const logger = Logger.getInstance(product, settings.isProduction);
